import { Text, TextColor, TextSize, TextWeight } from '@vizit/atoms';
import { Star06Icon } from '@vizit/icons';

interface SparkUnavailableProps {
  /**
   * The main title text to display
   * @default "Spark not available on hero images"
   */
  title?: string;
  /**
   * The subtitle/description text to display
   * @default "You can only apply spark to carousel images."
   */
  subtitle?: string;
}

/**
 * Unavailable state component for Spark
 * Displays when Spark feature is not available for the current image type
 */
export const SparkUnavailable = (props: SparkUnavailableProps) => {
  const {
    title = 'Spark for hero images coming soon!',
    subtitle = 'Currently, Spark only applies to carousel images.',
  } = props;

  return (
    <div className="flex flex-col justify-start items-center h-full text-center gap-8 lg:justify-center">
      <div className="flex items-center justify-center shrink-0 w-24 h-24 border border-primary shadow-xs">
        <Star06Icon size={20} className="text-secondary" />
      </div>

      <div className="flex flex-col gap-4">
        <Text size={TextSize.Md} weight={TextWeight.Semibold} color={TextColor.Primary}>
          {title}
        </Text>
        <Text size={TextSize.Sm} color={TextColor.Tertiary}>
          {subtitle}
        </Text>
      </div>
    </div>
  );
};
